import { React, PT, connect } from '@gasbuddy/react';
import { Dropdown } from 'semantic-ui-react';
import { Action } from '../../reducers/actions';

class BrandDropdown extends React.Component {
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({
      type: Action.Poi.BrandsRequested,
      meta: { apiAction: true },
      payload: {
        url: '/poi/brand',
      },
    });
  }

  render() {
    const { brands, brandChange } = this.props;
    return (
      <Dropdown options={brands} onChange={brandChange} placeholder="Pick a brand" fluid search />
    );
  }
}


BrandDropdown.propTypes = {
  dispatch: PT.func.isRequired,
  brands: PT.arrayOf(PT.shape({
    key: PT.number,
    text: PT.string,
    value: PT.number,
  })).isRequired,
  brandChange: PT.func.isRequired,
};


export const BrandDropDown = connect(
  (state) => {
    state.brands = [];
    if (state.brand.listing) {
      state.brands = state.brand.listing.map((brand) => {
        const option = {
          key: brand.brand_id,
          text: brand.name,
          value: brand.brand_id,
        };
        return option;
      });
    }
    return state;
  },
)(BrandDropdown);
